import React, { Component } from 'react'

import { connect } from 'react-redux';
import * as actions from 'actions';
import { compose, bindActionCreators } from 'redux';

import StepZilla from 'react-stepzilla';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import DXFormStep from './DXFormStep.jsx';
import DXFormSelectMember from './DXFormSelectMember.jsx';
import DXFormResultStep from './DXFormResultStep.jsx';

import './form.css';

import { getFormDataFromSku } from './helper';

import styles from "./DXFormStyles"

export class DXForm extends Component {

  constructor(props) {
    super(props);

    const { sku, target, doc = null } = this.props;
    const data = getFormDataFromSku(sku);
    const { title, sections } = data;
    this.props.setFormData(data, target, doc ? doc.valueState : null);

    this.state = {
      title,
      sections,
    }
  }

  render() {
    const { title, sections } = this.props.form;
    const { target } = this.props;

    if (!sections) {
      return null;
    }

    const steps = sections.map((section, index) => {
      return {
        name: section.title,
        component: <DXFormStep
          key={section.id}
          page={index}
          {...this.props}
        />,
      }
    })

    if (!target) {
      steps.unshift({
        name: '대상자 선택',
        component: <DXFormSelectMember {...this.props} />
      });
    }

    steps.push({
      name: '결과',
      component: <DXFormResultStep />
    })

    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={10} justify="center" container>
          <h1>{title}</h1>
        </GridItem>
        <GridItem xs={12} sm={10}>
          <div className="step-progress">
            <StepZilla
              showNavigation={true}
              showSteps={true}
              stepsNavigation={false}
              steps={steps}
              nextTextOnFinalActionStep="저장하기"
              nextButtonText={'다음'}
              backButtonText={'이전'}
              onStepChange={(step) => {
                console.log('onStepChange = ', step)
              }}
              nextButtonCls={"btn btn-prev btn-primary btn-md float-right"}
              backButtonCls={"btn btn-next btn-primary btn-md float-left"}
              prevBtnOnLastStep={false}
            />
          </div>
        </GridItem>
      </GridContainer>
    )
  }
}



const mapStateToProps = (state) => {
  return {
    currentUser: state.auth.currentUser,
    form: state.form,
    members: state.member.members,
    org: state.org,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(DXForm);